import { useApp } from '../../context/AppContext';
import './Settings.css';

const Settings = () => {
  const { resetSettings, clearAllFiles, showNotification, goBack, setCurrentView } = useApp();

  const handleResetSettings = () => {
    if (confirm('Are you sure you want to reset all settings to defaults?')) {
      resetSettings();
      showNotification('Settings reset to defaults', 'info');
    }
  };

  const handleClearAllFiles = () => {
    if (confirm('Are you sure you want to clear all uploaded files? This cannot be undone.')) {
      clearAllFiles();
      showNotification('All files cleared', 'info');
      setCurrentView('upload');
    }
  };

  return (
    <div className="settings-container">
      <div className="settings-header">
        <h2>Settings</h2>
        <button className="btn btn-ghost" onClick={goBack}>
          Close
        </button>
      </div>

      <div className="settings-content">
        <div className="settings-section">
          <h3>Data Management</h3>

          <div className="setting-item">
            <div className="setting-info">
              <span className="setting-label">Clear All Files</span>
              <span className="setting-description">
                Remove all uploaded PDF files from the app
              </span>
            </div>
            <button className="btn btn-danger" onClick={handleClearAllFiles}>
              Clear Files
            </button>
          </div>

          <div className="setting-item">
            <div className="setting-info">
              <span className="setting-label">Reset Settings</span>
              <span className="setting-description">
                Reset all settings to their default values
              </span>
            </div>
            <button className="btn btn-secondary" onClick={handleResetSettings}>
              Reset to Defaults
            </button>
          </div>
        </div>

        <div className="settings-section">
          <h3>About</h3>
          <div className="about-info">
            <p><strong>GoSplitPDF</strong></p>
            <p>Version 1.0.0</p>
            <p className="privacy-note">
              Most PDF processing is done locally in your browser to ensure your data remains private and secure.
            </p>
          </div>
        </div>
      </div>

      <div className="settings-footer">
        <button className="btn btn-secondary" onClick={goBack}>
          Close
        </button>
      </div>
    </div>
  );
};

export default Settings;
